import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import {
  UpgradePlanDialogComponent,
  UpgradePlanDialogData,
} from "src/app/pages/upgrade-plan-dialog/upgrade-plan-dialog.component";

/** Upgrade dialog `feature` keys for things the Starter free trial doesn't include. */
export type TrialGateFeature = "trial-ai" | "trial-guide-packs" | "trial-guides" | "trial-org";

const TRIAL_ERROR_FEATURES: Record<string, TrialGateFeature> = {
  trial_ai_disabled: "trial-ai",
  trial_guide_packs_disabled: "trial-guide-packs",
  trial_max_guides: "trial-guides",
  trial_org_disabled: "trial-org",
};

const TRIAL_TOAST_TITLES: Record<TrialGateFeature, string> = {
  "trial-ai": "Not included in your trial",
  "trial-guide-packs": "Not included in your trial",
  "trial-guides": "Trial guide limit reached",
  "trial-org": "Not included in your trial",
};

export function openTrialUpgradeDialog(
  dialog: MatDialog,
  feature: TrialGateFeature,
  returnUrl?: string | null
): void {
  const data: UpgradePlanDialogData = {
    returnUrl: returnUrl || undefined,
    feature,
  };

  dialog.open(UpgradePlanDialogComponent, {
    width: "780px",
    maxWidth: "100vw",
    maxHeight: "100vh",
    panelClass: "upgrade-plan-dialog-pane",
    autoFocus: false,
    restoreFocus: false,
    data,
  });
}

/** 403 responses from the API for Starter trial limits (trial_max_guides, trial_ai_disabled, ...). */
export function isTrialLimitError(err: unknown): boolean {
  const e = err as { status?: number; error?: { code?: string; error?: string } };
  const code = e?.error?.code || e?.error?.error || "";
  return e?.status === 403 && !!TRIAL_ERROR_FEATURES[code];
}

export function handleTrialLimitError(
  dialog: MatDialog,
  toastr: ToastrService,
  err: unknown,
  returnUrl?: string | null
): void {
  const e = err as { error?: { code?: string; error?: string; message?: string } };
  const feature = TRIAL_ERROR_FEATURES[e?.error?.code || e?.error?.error || ""] || "trial-guides";
  if (e?.error?.message) {
    toastr.warning(e.error.message, TRIAL_TOAST_TITLES[feature]);
  }
  openTrialUpgradeDialog(dialog, feature, returnUrl);
}
